import styled from 'styled-components';

const MOBILE_MAX = '882px';
const DESKTOP_MIN = '883px';
const TABLET_MAX = '1199px';
const FULL_DESKTOP_MIN = '1200px';

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #22aa52;
  overflow: hidden;

  @media (min-width: ${DESKTOP_MIN}) {
    height: 72px;
  }

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    padding: 0 16px;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    padding: 0 32px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    height: 104px;
    align-items: stretch;
    padding: 0;
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  width: 100%;
  height: 100%;

  @media (min-width: ${DESKTOP_MIN}) {
    align-items: center;
    height: 72px;
  }

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    justify-content: center;
    gap: 32px;
    max-width: 100%;
    flex-shrink: 0;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    justify-content: center;
    gap: 60px;
    max-width: 1402px;
    flex-shrink: 0;
  }

  @media (max-width: ${MOBILE_MAX}) {
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 88px;
    padding: 8px 16px;
  }
`;

export const PromoSection = styled.div`
  display: flex;
  align-items: center;

  @media (min-width: ${DESKTOP_MIN}) {
    height: 44px;
  }

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    gap: 48px;
    flex-shrink: 0;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    gap: 200px;
    flex-shrink: 0;
  }

  @media (max-width: ${MOBILE_MAX}) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 0;
    flex: 1;
    min-width: 0;
    height: auto;
  }
`;

export const HeadlineGroup = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    gap: 6px;
    width: auto;
    flex-shrink: 0;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    gap: 9px;
    width: 562px;
    max-width: 100%;
  }

  @media (max-width: ${MOBILE_MAX}) {
    display: none;
  }
`;

export const BonusGroup = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 44px;

  @media (max-width: ${MOBILE_MAX}) {
    height: auto;
  }
`;

export const Headline = styled.p`
  margin: 0;
  padding-right: 10px;
  font-family: 'Rubik', sans-serif;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  white-space: nowrap;

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    font-size: clamp(18px, 2.2vw, 24px);
    line-height: 26px;
    padding-right: 4px;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    font-size: 32px;
    line-height: 26px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    display: none;
  }
`;

export const MobileBlock = styled.div`
  display: none;

  @media (max-width: ${MOBILE_MAX}) {
    display: block;
  }
`;

export const MobileHeadline = styled.p`
  margin: 0;
  font-family: 'Rubik', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #fff;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const MobileGainRow = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 2px;
`;

export const MobileGainText = styled.span`
  font-family: 'Rubik', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 26px;
  color: #fff;
  text-transform: uppercase;
`;

export const VoucherWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    width: 24px;
    height: 24px;
    margin-right: -2px;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    width: 28.222px;
    height: 28.533px;
    margin-right: -4px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    width: 22.222px;
    height: 21.481px;
    margin-right: 0;
  }
`;

export const VoucherRotate = styled.div`
  display: flex;
  flex-shrink: 0;
  transform: rotate(90deg);
`;

export const VoucherInner = styled.div`
  position: relative;
  flex-shrink: 0;

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    width: 24px;
    height: 24px;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    width: 28.533px;
    height: 28.222px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    width: 22.222px;
    height: 21.481px;
  }
`;

export const VoucherIcon = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`;

export const BonusAmountWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 44px;

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    width: auto;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    width: 137px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    width: auto;
    min-width: 0;
    height: auto;
  }
`;

export const BonusAmount = styled.span`
  font-family: 'Rubik', sans-serif;
  font-weight: 700;
  color: #bcf738;
  text-transform: uppercase;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  letter-spacing: -1.4815px;
  white-space: nowrap;
  line-height: 37.037px;

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    font-size: 28px;
    line-height: 32px;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    font-size: 36px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    font-size: 26.667px;
    line-height: 26px;
  }
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.2);
  flex-shrink: 0;

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    padding: 4px 10px;
    height: auto;
    min-height: 26px;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    padding: 6px 12px;
    height: 30px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    margin-top: 6px;
    padding: 2px 8px;
    min-height: 23px;
    height: auto;
  }
`;

export const BadgeText = styled.span`
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-style: italic;
  color: #fff;
  text-transform: lowercase;
  white-space: nowrap;

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    font-size: 14px;
    line-height: 16px;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    font-size: 20px;
    line-height: 18px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const CountdownSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;

  @media (min-width: ${DESKTOP_MIN}) {
    width: 127px;
    flex-shrink: 0;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    width: 139px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    margin-top: 0;
    align-self: center;
    flex-shrink: 0;
  }
`;

export const CountdownLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-bottom: 2px;
  width: 100%;

  @media (max-width: ${MOBILE_MAX}) {
    gap: 5px;
    margin-bottom: 4px;

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export const CountdownLabelText = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  line-height: normal;
  color: #fff;
  white-space: nowrap;

  @media (min-width: ${DESKTOP_MIN}) {
    font-size: 12px;
  }
`;

export const CountdownBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 4.5px;

  @media (min-width: ${DESKTOP_MIN}) {
    gap: 4.5px;
    width: 127px;
    padding: 4.5px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    gap: 6px;
    width: 127px;
    padding: 6px;
    border-radius: 6px;
  }
`;

export const CountdownTime = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  line-height: normal;
  color: #ff6c1c;
  white-space: nowrap;

  @media (min-width: ${DESKTOP_MIN}) and (max-width: ${TABLET_MAX}) {
    font-size: 18px;
  }

  @media (min-width: ${FULL_DESKTOP_MIN}) {
    font-size: 20px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    font-size: 28px;
  }
`;

export const ProgressBarTrack = styled.div`
  position: relative;
  width: 100%;
  height: 3.4px;
  border-radius: 2.3px;
  background: #e1e1e1;
  overflow: hidden;

  @media (max-width: ${MOBILE_MAX}) {
    height: 4.5px;
    border-radius: 3px;
  }
`;

export const ProgressBarFill = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 2.3px;
  background: #ff6c1c;
  width: ${({ progress }) => `${progress}%`};
  transition: width 1s linear;

  @media (max-width: ${MOBILE_MAX}) {
    border-radius: 3px;
  }
`;
